import { combineReducers } from 'redux';

import fiatWithdrawals from './withdrawals/reducer';
import fiatPending from './pending/reducer';
import fiatDeposit from './deposit/reducer';

export default combineReducers({
  fiatDeposit,
  fiatPending,
  fiatWithdrawals,
});
